// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCb7DpoI0_6X0P2IBjJJ8y5-iRYlNDlUFY",
  authDomain: "qr-code-21455.firebaseapp.com",
  projectId: "qr-code-21455",
  storageBucket: "qr-code-21455.firebasestorage.app",
  messagingSenderId: "326246056166",
  appId: "1:326246056166:web:36b8170c1008b095b2bb27",
  measurementId: "G-R95JC8G9ZH"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyA9dD5gjb-eSBWxREtd1a3ysBuEuyo8df0",
//   authDomain: "qrcode-6e6d0.firebaseapp.com",
//   projectId: "qrcode-6e6d0",
//   storageBucket: "qrcode-6e6d0.firebasestorage.app",
//   messagingSenderId: "1092078096946",
//   appId: "1:1092078096946:web:58e56a6495eea973c1a22b",
//   measurementId: "G-KXV6X0BTQM"
// };

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

const analytics = getAnalytics(app);
// export const db = getFirestore(app);





// ❗ initialize only once

export const db = getFirestore(app);
